import { nanoid } from "nanoid";
import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { ISessionState } from "../interfaces/SessionState.interface";

export const useSessionState = create<ISessionState>()(
  persist(
    devtools(
      (set, get) => ({
        session_id: "",
        active_user: "",
        active_device: "",
        current_country: "",
        aiAdvisorStage: "stage0",
        setSessionId: () => set({ session_id: nanoid(16) }),
        setActiveUser: (identifier: string) => set({ active_user: identifier }),
        setActiveDevice: (identifier: string) =>
          set({ active_device: identifier }),
        setCurrentCountry: (country: string) =>
          set({ current_country: country }),
        setAiAdvisorStage: (stage: "stage0" | "stage1" | "stage2" | "stage3") =>
          set({ aiAdvisorStage: stage }),
      }),
      {
        enabled: true,
      }
    ),
    {
      name: "SO_1113",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const { getState: sessionState } = useSessionState;
